module.exports = {
  ACQUIRING_FEE: 'acquiring_fee',
  ADMINISTRATIVE_ACQUIRER_FEE: 'administrative_acquirer_fee',
  RISK_ASSESSMENT_FEE: 'risk_assessment_fee',
  ACCEPTANCE_FEE: 'acceptance_fee',
  AUTHENTICATION_FEE: 'authentication_fee',
  PAYOUT_FEE: 'payout_fee',
};
